module.exports = __webpack_public_path__ + "img/AVSecurities_Logootipo_Índigo.36a1d609.png";